import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-section-header',
  templateUrl: './section_header.component.html',
  styleUrls: ['./section_header.component.scss'],
})
export class SectionHeaderComponent implements OnInit {
  @Input() title: string;
  @Input() subtitle?: string;

  constructor() {}

  ngOnInit(): void {}
}
